module.exports = __webpack_public_path__ + "html/terms-of-service_08ceeb83c6f1e8a3c47371c489644c1c.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/terms-of-service.html
// module id = lGv7
// module chunks = 153